import { useQuery } from "@tanstack/react-query";

import {
  closedPeriodService,
  ClosedPeriod,
} from "~/services/contabilidad/closedPeriodService";

export const CLOSED_PERIODS_QUERY_KEY = ["closed-periods"];

export function useClosedPeriods() {
  return useQuery({
    queryKey: CLOSED_PERIODS_QUERY_KEY,
    queryFn: () => closedPeriodService.getAll(),
  });
}

export function useIsMonthClosed(year: number, month: number): boolean {
  const { data: closedPeriods = [] } = useClosedPeriods();
  return closedPeriods.some(
    (p) => p.year === year && p.month === month && p.is_closed
  );
}

export function useClosedMonthsSet(): Set<string> {
  const { data: closedPeriods = [] } = useClosedPeriods();
  return new Set(
    closedPeriods.map((p) => `${p.year}-${String(p.month).padStart(2, "0")}`)
  );
}
